export default "__VITE_ASSET__CwOkkIhU__"